import React from "react";
import InformationCard from "./InformationCard";
import { faBrain, faHandsHelping, faHeartbeat } from "@fortawesome/free-solid-svg-icons";
import "../Styles/Info.css";
import { useTranslation } from 'react-i18next';

function Info() {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'he'; // Check if the current language is Hebrew

  return (
    <div className={`info-section ${isRTL ? 'rtl' : ''}`} id="services">
      <div className="info-title-content">
        <h3 className="info-title">
          <span>{t("whatWeDo")}</span>
        </h3>
        <p className="info-description">
          {t("infoDescription")}
        </p>
      </div>

      <div className="info-cards-content">
        <InformationCard
          title={t("ptsdTreatmentTitle")}
          description={t("ptsdTreatmentDescription")}
          icon={faBrain}
        />

        <InformationCard
          title={t("emotionalSupportTitle")}
          description={t("emotionalSupportDescription")}
          icon={faHandsHelping}
        />

        <InformationCard
          title={t("holisticMentalHealthTitle")}
          description={t("holisticMentalHealthDescription")}
          icon={faHeartbeat}
        />
      </div>
    </div>
  );
}

export default Info;
